module.exports = __webpack_public_path__ + "static/media/pxiEyp8kv8JHgFVrJJbecnFHGPezSQ.790d0c8d.woff2";